export default __webpack_public_path__ + "static/media/l2data.0a84f89b.svg";